// extracted by css-extract-rspack-plugin
export default {"error":"error-YjvCFE","errorTitle":"errorTitle-L632C9","errorText":"errorText-bB91J8","errorDev":"errorDev-wL6M1f","errorButton":"errorButton-o86ulo"};